var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMongo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "240px",
    height: "240px",
    fillRule: "nonzero",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#c92020",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M128,256c-70.69245,0 -128,-57.30755 -128,-128v0c0,-70.69245 57.30755,-128 128,-128v0c70.69245,0 128,57.30755 128,128v0c0,70.69245 -57.30755,128 -128,128z",
    id: "shape"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(5.33333,5.33333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42,17.3c0,20.5 -18,26.7 -18,26.7c0,0 -18,-6.2 -18,-26.7c0,-2.5 0.2,-4.6 0.4,-6.3c0.3,-2.5 2,-4.5 4.4,-5.1c3.1,-0.9 8,-1.9 13.2,-1.9c5.2,0 10.1,1 13.3,1.9c2.4,0.6 4.1,2.7 4.4,5.1c0.1,1.7 0.3,3.9 0.3,6.3z",
    fill: "#5d4037"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,7c4.9,0 9.5,1 12.5,1.8c1.2,0.3 2,1.3 2.2,2.6c0.2,1.9 0.3,3.9 0.3,5.9c0,15.6 -11.5,21.9 -15,23.4c-3.5,-1.6 -15,-7.9 -15,-23.4c0,-2 0.1,-4 0.3,-5.9c0.1,-1.3 1,-2.3 2.2,-2.6c3,-0.8 7.6,-1.8 12.5,-1.8M24,4c-5.2,0 -10.1,1 -13.3,1.9c-2.3,0.6 -4.1,2.7 -4.3,5.1c-0.2,1.7 -0.4,3.9 -0.4,6.3c0,20.5 18,26.7 18,26.7c0,0 18,-6.2 18,-26.7c0,-2.5 -0.2,-4.6 -0.4,-6.3c-0.3,-2.5 -2,-4.5 -4.4,-5.1c-3.1,-0.9 -8,-1.9 -13.2,-1.9z",
    fill: "#4caf50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23,28h2v8h-2z",
    fill: "#dcedc8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,10c0,0 -6,5 -6,13c0,5.2 3.3,8.5 5,10l1,-3l1,3c1.7,-1.5 5,-4.8 5,-10c0,-8 -6,-13 -6,-13z",
    fill: "#4caf50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,10c0,0 -6,5 -6,13c0,5.2 3.3,8.5 5,10l1,-3z",
    fill: "#81c784"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMongo);
export default __webpack_public_path__ + "static/media/mongo.c46708bc737022dcd4daf70da56aef94.svg";
export { ForwardRef as ReactComponent };